import Common from "../common/common";
import PinSection from "~/js/home/pin-section";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import BrandSideNavi from "~/js/brands/brand-side-navi";
import BrandNews from "~/js/brands/news";
import Accordion from "~/js/common/accordion";
import Tooltip from "~/js/common/tooltip";
import store from "~/js/store/store";
export default class BrandTop {
  constructor() {
    //Common.init();
    store.dispatch("setIsPinsection");
    store.subscribe((mutation, state) => {
      if (mutation.type === "init") {
        Common.init();
        /// Common.setupScrollY(true);
      } else if (mutation.type === "beforeScroll") {
        if (this.sideNavi) {
          this.sideNavi.updateNavi();
          this.sideNavi.updateColor();
        }
        if (this.header) {
          this.header.updateHeaderColor();
        }
        const collections = store.getters["isDoubleCollection"];
        if (collections === 0) {
          // 通常コンポーネント
          store.dispatch("multiImage", {
            length: 0,
            count: 0
          });
        } else {
          // マルチイメージコンポーネント
          store.dispatch("multiImage", {
            length: collections,
            count: 0
          });
        }
      } else if (mutation.type === "beforeMultiImageChange") {
        if (this.header) {
          this.header.execHeaderColor(store.state.pin.multiImageColor);
        }
      } else if (mutation.type === "afterScroll") {
        this.updateBreadCrumb(state.app.pinSection.nextIndex);
      }
    });
    this.header = new Header();
    this.footer = new Footer();
    this.sideNavi = new BrandSideNavi();
    this.brandNews = new BrandNews();
    this.accordion = new Accordion();
    this.pinSection = new PinSection();
    new Tooltip();
  }

  updateBreadCrumb(nextIndex) {
    let breadcrumb = document.querySelector(".breadcrumb");
    if (!breadcrumb) {
      return;
    }
    if (nextIndex === 0) {
      breadcrumb.classList.remove("invisible");
    } else {
      breadcrumb.classList.add("invisible");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new BrandTop();
});
